import {
  type UseMutationOptions,
  type UseMutationResult,
  useMutation,
} from '@tanstack/react-query';

import api from 'src/axios';

type DeleteCriteriaFromSessionVariables = {
  sessionId: string;
  name: string;
};

export const useDeleteCriteriaFromSession = (
  options?: Omit<
    UseMutationOptions<void, Error, DeleteCriteriaFromSessionVariables>,
    'mutationFn'
  >,
): UseMutationResult<void, Error, DeleteCriteriaFromSessionVariables> => {
  return useMutation({
    mutationFn: async ({
      sessionId,
      name,
    }: DeleteCriteriaFromSessionVariables) => {
      const { data } = await api.delete(
        `/sales-forecasting-sessions/${sessionId}/criteria/${name}`,
      );
      return data;
    },
    ...options,
  });
};
